
import type { PropType } from 'vue'
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
    props: {
        photos: {
            type: Array as PropType<string[]>,
            default: () => []
        }
    },
    setup(props) {
        const isPreviewOpened = ref(false)
        const currentPhoto = ref(0)
        const photoItems = ref<HTMLElement[]>([])

        const openPreview = (photoIndex: number) => {
            currentPhoto.value = photoIndex
            isPreviewOpened.value = true
        }

        const closePreview = () => {
            isPreviewOpened.value = false
        }

        const onPrevious = () => {
            if (currentPhoto.value === 0) return
            currentPhoto.value = currentPhoto.value - 1
        }

        const onNext = () => {
            if (currentPhoto.value === props.photos.length - 1) return
            currentPhoto.value = currentPhoto.value + 1
        }

        watch(currentPhoto, () => {
            photoItems.value[currentPhoto.value]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            })
        })

        return {
            currentPhoto,
            photoItems,
            isPreviewOpened,
            openPreview,
            closePreview,
            onPrevious,
            onNext
        }
    }
})
